export var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["AVAILABLE"] = "AVAILABLE";
    InvoiceStatus["PROCESSING"] = "PROCESSING";
    InvoiceStatus["PENDING"] = "PENDING";
})(InvoiceStatus || (InvoiceStatus = {}));
export const getInvoiceState = (rechargeState, invoices = null) => {
    const hasInvoices = invoices !== null && invoices.length > 0;
    const safeInvoices = invoices || [];
    const availableInvoices = safeInvoices.filter(invoice => invoice.invoiceUrl && invoice.invoiceUrl.trim() !== '');
    const hasAvailableInvoices = availableInvoices.length > 0;
    const availableInvoicesCount = availableInvoices.length;
    if (!hasInvoices && rechargeState === 'PENDING') {
        return {
            status: InvoiceStatus.PENDING,
            hasInvoices: false,
            hasAvailableInvoices: false,
            availableInvoicesCount: 0,
        };
    }
    if (hasInvoices && !hasAvailableInvoices) {
        return {
            status: InvoiceStatus.PROCESSING,
            hasInvoices: true,
            hasAvailableInvoices: false,
            availableInvoicesCount: 0,
        };
    }
    if (hasAvailableInvoices) {
        return {
            status: InvoiceStatus.AVAILABLE,
            hasInvoices: true,
            hasAvailableInvoices: true,
            availableInvoicesCount,
        };
    }
    return {
        status: InvoiceStatus.PENDING,
        hasInvoices,
        hasAvailableInvoices: false,
        availableInvoicesCount: 0,
    };
};
export const openInvoice = (invoiceUrl) => {
    if (!invoiceUrl || invoiceUrl.trim() === '') {
        return;
    }
    window.open(invoiceUrl, '_blank', 'noopener,noreferrer');
};
export const handleInvoiceVisualization = (invoices) => {
    const safeInvoices = invoices || [];
    const availableInvoices = safeInvoices.filter(invoice => invoice.invoiceUrl && invoice.invoiceUrl.trim() !== '');
    if (availableInvoices.length === 0) {
        return;
    }
    if (availableInvoices.length === 1) {
        openInvoice(availableInvoices[0].invoiceUrl);
        return;
    }
    availableInvoices.forEach(invoice => {
        window.open(invoice.invoiceUrl, '_blank', 'noopener,noreferrer');
    });
};
